var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('core-stakeholders-card',{attrs:{"claimId":_vm.claimId,"stakeholders":_vm.stakeholders,"stakeholdersOf":"claim","types":_vm.types},on:{"stakeholder:added":_vm.fetchStakeholders,"stakeholder:removed":_vm.removeStakeholder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }